// src/utils/layoutUtils.ts

import { GridRow } from "../types/Layout";

const createEmptyGrid = (rows: number, columns: number): GridRow[] => {
  return Array(rows).fill(null).map(() => ({
    cells: Array(columns).fill(null).map(() => ({
      widgetName: null,
      size: 100 / columns
    })),
    size: 100 / rows
  }));
};

export const resizeGrid = (currentGrid: GridRow[], newRows: number, newColumns: number): GridRow[] => {
  const newGrid = createEmptyGrid(newRows, newColumns);

  // Copy existing widgets and sizes where possible
  for (let i = 0; i < Math.min(currentGrid.length, newRows); i++) {
    newGrid[i].size = currentGrid[i].size;
    for (let j = 0; j < Math.min(currentGrid[i].cells.length, newColumns); j++) {
      newGrid[i].cells[j].widgetName = currentGrid[i].cells[j].widgetName;
      newGrid[i].cells[j].size = currentGrid[i].cells[j].size;
    }
  }

  return newGrid;
};